import React, { useEffect, useState } from "react";
import {
  Drawer,
  Image,
  Skeleton,
  Typography,
} from "antd";
import { patientInvestigationsViewAPI } from "../../../../services/patient.services";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import AllImageView from "./AllImageView";
import "./AllImageView.css";
import "./InvestigationGallery.css";
import bedImg from "../../../../assets/images/patientIcons/bed.svg";
import useIsMobile from "../../../../hooks/useIsMobile";
import { UiTag } from "../../../ui";
import { formatPatientAge } from "../../../../helpers/formatAge";
import "../../../Receptionist/receptionistMobileForms.css";

const InvestigationGallery = ({ open, setOpen, id, editData, patientData }) => {
  const isMobile = useIsMobile();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);

  useEffect(() => {
    setLoading(true);
    patientInvestigationsViewAPI(
      `patient_id=${id || editData?.ip_admission_id}&ip_admission=${
        id || editData?.ip_admission_id
      }&gallery=true`
    )
      .then((res) => {
        setData(res?.data);
        setFilteredData(res?.data?.filter((item) => item?.id === editData?.id));
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [editData?.id, id]);

  const patientName = `${patientData?.patient?.first_name || ""} ${
    patientData?.patient?.last_name || ""
  }`.trim();
  const bedNo = patientData?.bed?.bed_no || patientData?.admission?.bed?.bed_no;
  const patientAgeGender = formatPatientAge(
    patientData?.patient?.age_by_dob ?? patientData?.patient?.age,
    patientData?.patient?.gender
  );
  const ipId = patientData?.ip_id || patientData?.admission?.ip_id;

  const mobileTitle = (
    <div className="investigation-gallery-mobile-header-wrap">
      <div className="investigation-gallery-mobile-header">
        <button
          type="button"
          className="investigation-gallery-mobile-header-icon"
          onClick={() => setOpen(false)}
          aria-label="Go back"
        >
          <LeftOutlined />
        </button>
        <Typography.Text className="investigation-gallery-mobile-header-title">
          Investigation Gallery
        </Typography.Text>
        <button
          type="button"
          className="investigation-gallery-mobile-header-icon"
          onClick={() => setOpen(false)}
          aria-label="Close"
        >
          <CloseOutlined />
        </button>
      </div>
    </div>
  );

  const desktopTitle = (
    <div className="investigation-gallery-desktop-header">
      <div className="investigation-gallery-desktop-patient">
        <div className="investigation-gallery-desktop-patient-row">
          <LeftOutlined
            onClick={() => setOpen(false)}
            className="investigation-gallery-desktop-back"
          />
          <Typography.Text className="investigation-gallery-desktop-name">
            {patientName || " "}
          </Typography.Text>
          {bedNo ? (
            <UiTag
              tone="warning"
              size="sm"
              className="investigation-gallery-bed-tag"
            >
              <Image
                src={bedImg}
                preview={false}
                width={14}
                height={14}
              />
              {bedNo}
            </UiTag>
          ) : null}
        </div>
        <div className="investigation-gallery-desktop-meta">
          {patientAgeGender ? (
            <UiTag tone="neutral" size="sm">
              {patientAgeGender}
            </UiTag>
          ) : null}
          {ipId ? (
            <UiTag tone="neutral" size="sm">
              IP ID: {ipId}
            </UiTag>
          ) : null}
        </div>
      </div>

      <div className="investigation-gallery-desktop-title-col">
        <Typography.Text className="investigation-gallery-desktop-title">
          Investigation Gallery
        </Typography.Text>
      </div>

      <button
        type="button"
        className="investigation-gallery-desktop-close"
        onClick={() => setOpen(false)}
        aria-label="Close gallery"
      >
        <CloseOutlined />
      </button>
    </div>
  );

  return (
    <Drawer
      width="100%"
      open={open}
      onClose={() => setOpen(false)}
      closeIcon={null}
      footer={null}
      rootClassName={
        isMobile
          ? "investigation-gallery-drawer reception-drawer-fullscreen"
          : "investigation-gallery-drawer"
      }
      styles={
        isMobile
          ? {
              header: {
                padding: "12px 16px",
                borderBottom: "1px solid #eef2f7",
                boxShadow: "none",
              },
              body: { padding: "12px 16px" },
            }
          : {
              header: {
                padding: "5px 20px",
                boxShadow: "rgb(34, 34, 34) 0px 2px 4px -4px",
              },
            }
      }
      title={isMobile ? mobileTitle : desktopTitle}
    >
      {loading ? (
        <Skeleton active />
      ) : (
        <AllImageView data={editData ? filteredData : data} isMobile={isMobile} />
      )}
    </Drawer>
  );
};

export default InvestigationGallery;
